/** Utilidades de fechas comerciales para facturas de venta (fechaVencim). */

export function toDateOnly(value: string | Date | null | undefined): Date | null {
  if (value == null || value === '') return null;
  const d = value instanceof Date ? new Date(value) : new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  d.setHours(0, 0, 0, 0);
  return d;
}

export function sameCalendarDay(a: string | Date | null | undefined, b: string | Date | null | undefined): boolean {
  const da = toDateOnly(a);
  const db = toDateOnly(b);
  if (!da || !db) return false;
  return da.getTime() === db.getTime();
}

export function defaultFechaVencimFromEmision(fechaEmision: string | Date): Date {
  const d = toDateOnly(fechaEmision);
  return d ?? new Date();
}

export { calcularFechaVencimDesdeVtoComprob, labelVtoComprob } from './vtoComprobCliente';

export function resolveFechaVencimForSave(
  fechaEmision: string | Date,
  fechaVencim?: string | Date | null,
): Date {
  const emision = toDateOnly(fechaEmision) ?? new Date();
  if (fechaVencim == null || fechaVencim === '') {
    return emision;
  }
  return toDateOnly(fechaVencim) ?? emision;
}

export function validarFechasFacturaVenta(
  fechaEmision: string | Date,
  fechaVencim?: string | Date | null,
  fechaVencimMinima?: string | Date | null,
): string | null {
  const emision = toDateOnly(fechaEmision);
  const vencim = resolveFechaVencimForSave(fechaEmision, fechaVencim);
  if (!emision) {
    return 'La Fecha de Emisión debe ser una fecha válida';
  }
  const minima = toDateOnly(fechaVencimMinima) ?? emision;
  if (vencim.getTime() < minima.getTime()) {
    return `La fecha de vencimiento no puede ser anterior a la sugerida (${minima.toLocaleDateString('es-AR')})`;
  }
  return null;
}

export function toFechaVencimISO(fecha: string | Date): string {
  const d = toDateOnly(fecha) ?? new Date();
  return d.toISOString();
}

export function toLocalDateInputValue(fecha: string | Date | null | undefined): string {
  const d = toDateOnly(fecha);
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isFechaVencida(fechaVencim: string | Date | null | undefined): boolean {
  const vencim = toDateOnly(fechaVencim);
  if (!vencim) return false;
  const hoy = toDateOnly(new Date());
  if (!hoy) return false;
  return vencim.getTime() < hoy.getTime();
}

export function formatFechaVencimDisplay(fecha: string | Date | null | undefined): string {
  const d = fecha instanceof Date ? fecha : fecha ? new Date(fecha) : null;
  if (!d || Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString();
}
